import Bottom from "./bottom";
import Immutable from "immutable";
import ListItemText from "@material-ui/core/ListItemText";
import PropTypes from "prop-types";
import React from "react";
import clsx from "clsx";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { List, ListItem, Collapse, Radio, RadioGroup, FormControlLabel } from "@material-ui/core";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import RadioButtonUncheckedRounded from "@material-ui/icons/RadioButtonUncheckedRounded";
import RadioButtonCheckedRounded from "@material-ui/icons/RadioButtonCheckedRounded";
import { toDataTest } from "helpers/test";
import { themeOptions } from "styles/theme";

const useRadioStyles = makeStyles({
    root: {
        width: 30,
        height: 30,
        "&:hover": {
            backgroundColor: "transparent !important",
        },
    },
    icon: {
        width: 24,
        height: 24,
    },
    uncheckedIcon: {
        color: "black",
    },
    checkedIcon: {
        color: "rgb(47, 199, 190)",
    },
});

const StyledRadio = (props) => {
    const classes = useRadioStyles();

    return (
        <Radio
            className={classes.root}
            icon={<RadioButtonUncheckedRounded className={clsx(classes.icon, classes.uncheckedIcon)} />}
            checkedIcon={<RadioButtonCheckedRounded className={clsx(classes.icon, classes.checkedIcon)} />}
            {...props}
        />
    );
};

class RadioFilter extends React.Component {
    static propTypes = {
        filter: PropTypes.object.isRequired,
        activeFiltersValues: PropTypes.instanceOf(Immutable.Map).isRequired,
        onChange: PropTypes.func.isRequired,
        lastFilter: PropTypes.bool,
        filtersDisabled: PropTypes.bool,
    };

    static defaultProps = {
        lastFilter: false,
    };

    styles = {
        nestedListItem: {
            backgroundColor: "transparent",
        },
        listItem: {
            fontSize: "14px",
            margin: 0,
            padding: "3px 16px 3px 8px",
            color: themeOptions.palette.darkerGrey,
        },
        listOpen: {
            backgroundColor: "white",
        },
        radioButton: {
            paddingLeft: "16px",
        },
        dropdownIcon: {
            fontSize: "24px",
            color: "#757575",
            transition: "transform .1s",
        },
        dropdownIconOpen: {
            msTransform: "rotate(-90deg)",
            WebkitTransform: "rotate(-90deg)",
            transform: "rotate(-90deg)",
        },
        label: {
            fontSize: "14px",
            fontFamily: "Lato, sans-serif",
            color: "rgb(45, 45, 45)",
        },
    };

    constructor(props) {
        super(props);
        this.handleToggleOpen = this.handleToggleOpen.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { filter, activeFiltersValues } = this.props;

        let values = activeFiltersValues.get(filter.__key);
        if (values) {
            if (typeof values === "string") {
                values = Immutable.List.of(values);
            }
        } else {
            values = Immutable.List();
        }
        this.setState({
            open: values.size || filter.__default_open ? true : false,
            activeFilterValues: values,
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.activeFiltersValues !== this.props.activeFiltersValues) {
            let values = nextProps.activeFiltersValues.get(this.props.filter.__key);
            if (this.state.activeFilterValues !== values) {
                if (typeof values === "string") {
                    values = Immutable.List.of(values);
                } else if (!values) {
                    values = Immutable.List();
                }
                this.setState({ activeFilterValues: values });
            }
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextState.activeFilterValues !== this.state.activeFilterValues || nextState.open !== this.state.open;
    }

    handleToggleOpen() {
        this.setState({ open: !this.state.open });
    }

    handleChange(e, value) {
        const { onChange, filter, activeFiltersValues } = this.props;
        const radioDefault = filter.__data.find((entry) => entry.__default);
        let radioFilters;

        if (radioDefault && radioDefault.__value === value) {
            radioFilters = activeFiltersValues.delete(filter.__key);
        } else {
            radioFilters = activeFiltersValues.set(filter.__key, value);
        }

        onChange(radioFilters);
    }

    render() {
        const { filter, lastFilter, filtersDisabled, activeFiltersValues } = this.props;
        const { open } = this.state;
        const styles = this.styles;

        const defaultRadio = filter.__data.find((item) => !!item.__default);
        const defaultValue = defaultRadio && defaultRadio.__value;

        const plainTitle = <span style={styles.label}>{filter.__name}</span>;

        return (
            <React.Fragment>
                <ListItem
                    data-test={`filter-${toDataTest(filter.__name)}`}
                    className="selectFilter"
                    button={true}
                    onClick={this.handleToggleOpen}
                    disabled={filtersDisabled}
                    style={{
                        ...styles.listItem,
                        ...(open ? styles.listOpen : {}),
                    }}
                >
                    <ListItemText primary={plainTitle} />
                    <ChevronLeft
                        style={{
                            ...styles.dropdownIcon,
                            ...(open ? styles.dropdownIconOpen : {}),
                        }}
                    />
                </ListItem>

                <Collapse
                    in={open}
                    unmountOnExit={true}
                    timeout={100}
                    style={{
                        ...styles.nestedListItem,
                        ...(open ? styles.listOpen : {}),
                    }}
                >
                    <List>
                        <RadioGroup
                            key={filter.__key}
                            name={filter.__key}
                            value={activeFiltersValues.get(filter.__key) || defaultValue}
                            onChange={this.handleChange}
                        >
                            {filter.__data.map((item, i) => (
                                <FormControlLabel
                                    data-test={`radio-${item.__label}`.replace(" ", "-").toLowerCase()}
                                    key={"radio-" + i}
                                    value={item.__value}
                                    control={<StyledRadio />}
                                    label={<span style={styles.label}>{item.__label}</span>}
                                    labelPlacement="end"
                                    style={styles.radioButton}
                                />
                            ))}
                        </RadioGroup>

                        {!lastFilter && <Bottom key="bottom" />}
                    </List>
                </Collapse>
            </React.Fragment>
        );
    }
}

export default RadioFilter;
